<template>
  <CForm @submit.prevent="saveMember">
    <CCard>
      <CCardHeader>
        {{ $t(isMemberCreate ? "Create" : "Edit") }} {{ $t("Member") }}
        <CButton class="mz-button v2-mz-btn mr-2" color="primary" type="submit">
          {{ $t("Save") }}
        </CButton>
      </CCardHeader>
      <CCardBody>
        <CCol col="6">
          <h5 v-if="isMemberCreate">{{ $t("New") }}{{ $t("Member") }}</h5>
          <div>
            <CRow class="w100">
              <CCol>
                <CInput
                  addInputClasses="mz-input"
                  label="Code GTA"
                  type="text"
                  v-model="member.code_gda"
                  required
                />
              </CCol>
              <CCol>
                <CInput
                  addInputClasses="mz-input"
                  :label="$t('Accounting Code')"
                  type="text"
                  v-model="member.code_cpt"
                />
              </CCol>
            </CRow>
            <CInput
              class="mt-1"
              addInputClasses="mz-input"
              :label="$t('Member Name')"
              v-model="member.name"
              required
            />
            <MzSelect
              class="mt-1"
              v-if="users && users.length"
              style="min-width: 150px;"
              :label="$t('User')"
              :value.sync="member.email"
              :options="users"
              searchable
            />
          </div>
        </CCol>
      </CCardBody>
    </CCard>
  </CForm>
</template>

<script>
import {MemberService} from "@/services/members";
import {users} from "@/services/users";

export default {
  name: "Member",
  data() {
    return {
      isMemberCreate: false,
      id_member: this.$route.params.id,
      member: {},
      users: [],
    };
  },
  async mounted() {
    this.users = (await users.getUsers(false)).map(user => {
      const displayName = user.firstname && user.lastname ? `${user.firstname} ${user.lastname}` : user.email;
      return {
        'label': displayName,
        'value': user.email,
      }
    }).sort((a, b) => a.label.localeCompare(b.label));
    this.isMemberCreate = this.id_member === "new";
    if (!this.isMemberCreate) {
      await this.fetchMember();
    }
  },
  methods: {
    async fetchMember() {
      this.member = await MemberService.getMember(this.id_member);
    },
    async saveMember() {
      if (!this.member.email) {
        alert(this.$t("You need to specify valid user for this member"), {
              action: {
                  text: this.$t('Close'),
                  icon: 'close',
                  onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                  }
              }
          })
        return
      }
      if (this.isMemberCreate) {
        const data = await MemberService.saveMember(this.member);

        if (!data?.id_member && data?.id_member !== 0) {
          return alert(this.$t(data.detail), {
              action: {
                  text: this.$t('Close'),
                  icon: 'close',
                  onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                  }
              }
          })

        }
        alert(this.$t("Member created successfully"), {
              action: {
                  text: this.$t('Close'),
                  icon: 'close',
                  onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                  }
              }
          })
        this.$router.push({name: "Members"});
      } else {
        const data = await MemberService.saveMember(this.member, this.id_member);
        if (!data.id_member) {
          return alert(`Error: ${data.detail}`, {
              action: {
                  text: this.$t('Close'),
                  icon: 'close',
                  onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                  }
              }
          })
        }
        alert(this.$t("Member saved successfully"), {
              action: {
                  text: this.$t('Close'),
                  icon: 'close',
                  onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                  }
              }
          });
        this.member = data;
        this.$router.push({name: "Members"});
      }
      this.isMemberCreate = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.input-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
</style>
